import type { FocusableElement } from '@react-types/shared';
import type React from 'react';

import { Button, ButtonLink } from '@coop/components';
import classNames from 'classnames';

import styles from './SkipLink.module.scss';

const SkipButton = (props: {
    href?: string;
    align?: 'start' | 'center';
    children: React.ReactNode;
    onClick?: (e: React.MouseEvent<FocusableElement>) => void;
    'aria-describedby'?: string;
}) => {
    const classes = classNames(
        styles.SkipLink,
        props.align === 'center' && styles['SkipLink--centered'],
        'u-noPrint',
    );

    if (props.href) {
        return (
            <ButtonLink
                href={props.href}
                theme="subtle"
                className={classes}
                size="large"
                onClick={props.onClick}
                aria-describedby={props['aria-describedby']}
            >
                {props.children}
            </ButtonLink>
        );
    }

    return (
        <Button
            theme="subtle"
            className={classes}
            size="large"
            onClick={props.onClick}
            aria-describedby={props['aria-describedby']}
        >
            {props.children}
        </Button>
    );
};

export default SkipButton;
